export default __webpack_public_path__ + "static/media/LinkArrow.37cd193d.svg";